import React from 'react'
import { Typography, Icon, Row, Col, Spin } from 'antd'
import IframeFile from '../../../components/user/IframeFile'
//////////////////////addmodalINTERNAL_SERVER_ERROR
const { Text, Title } = Typography

class PolicyDocumentsDetail extends React.PureComponent {

    state = {
        detailPolicy: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false
    }

    async componentDidMount() {
        const { match, detailPolicy } = this.props
    }

    render() {
        const { match, detailPolicy } = this.props
        // const { detailPolicy } = this.state

        console.log(detailPolicy)
        return (
            <div match={match}>
                <Row>
                    {
                        detailPolicy &&
                        <Col>
                            <Title level={3}>{ detailPolicy.docTitle }</Title>
                            <div className="mb-3">
                                <Text>{ detailPolicy.docDescription }</Text>
                            </div>
                            {
                                //pendtest
                                detailPolicy.fileData &&
                                <IframeFile typeFile={detailPolicy.fileData.fileMimeType}  file={detailPolicy.fileData.fileId}/>
                            }
                            
                            {/* {
                                detailPolicy.linkFile &&
                                //produtionsWeb
                                <div style={{ width:"100%",position:"relative", overflow:"hidden",paddingTop:"56.25%" }}>
                                    <div style={{ width: "100%", height: "100%",position:"absolute",top:"0" }} dangerouslySetInnerHTML={{ __html:  '<iframe src='+detailPolicy.linkFile+' width="100%" height="100%" style="border:0" className="mt-3"></iframe>' }} />
                                </div>
                             } */}

                           
                        </Col>
                        ||
                        <Col align="center" className="mt-5">
                            <Spin size="large" />
                        </Col>
                    }
                </Row>
            </div>
        )
    }
}

PolicyDocumentsDetail.propTypes = {
    //
}

export default PolicyDocumentsDetail